import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { useConnectStore } from '../../../store/models';
import useConnectErrors from '../../../store/models/connect/errors/useConnectErrors';
import useModuleErrorDialog from '../../../store/models/error/useModuleErrorDialog';
import ConnectIntegrationPage from './views/connectIntegrationPage';
import PlansBrowseView from './views/plansBrowseView';
import ConnectPageSkeleton from './views/connectPageSkeleton';
import useConnectIntegrationByDev from './useConnectIntegrationByDev';

function ConnectPage () {
    const connectStore = useConnectStore();
    const { errors } = useConnectErrors();
    const { renderErrorDialog } = useModuleErrorDialog({ errors });
    const { devAccess } = useConnectIntegrationByDev();
    // Local, per-mount resolution flag — deliberately not derived from
    // observed.currentPlan (that uuid token stays truthy forever once set, so
    // on remount it would read as "resolved" using the *previous* mount's
    // stale currentPlan before this mount's getCurrentPlan() call finishes).
    const [currentPlanResolved, setCurrentPlanResolved] = useState(false);

    const hasConnectPlan = currentPlanResolved && !!connectStore.currentPlan;

    useEffect(() => {
        let cancelled = false;
        connectStore.getCurrentPlan().then(() => {
            if (!cancelled) {
                setCurrentPlanResolved(true);
            }
        });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line
    }, []);

    function renderPlansBrowseView () {
        return <PlansBrowseView />;
    }

    function renderView () {
        // Temporarily only allow developers to access this.
        if (!devAccess) {
            return null;
        }

        if (!currentPlanResolved) {
            return <ConnectPageSkeleton />;
        }

        if (!hasConnectPlan) {
            return renderPlansBrowseView();
        }

        return <ConnectIntegrationPage
                    currentPlan={connectStore.currentPlan}
                    />;
    }

    return (
        <React.Fragment>
            {renderView()}
            {renderErrorDialog()}
        </React.Fragment>
    );
}

const ObservedConnectPage = observer(ConnectPage);
export default ObservedConnectPage;
